import React, { useEffect, useRef, useState } from "react";
import "./Product_details_swiper.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Best_seller_heart from "../../common-components/product_card/Best_seller_heart/Best_seller_heart";
import "react-medium-image-zoom/dist/styles.css";
import { Autoplay } from "swiper/modules";

function Product_details_swiper({
  selectedVariant,
  product,
  activeMetal,
  activeSize,
  activeTriple,
}) {
  const [activeImage, setActiveImage] = useState("");

  const [productImages, setproductImages] = useState([]);

  // const productImages = [
  //   product?.image,
  //   ...(product?.Product_Images?.map((item) => item?.image) || []),
  // ].filter(
  //   (img, index, self) => img && img !== "null" && self.indexOf(img) === index,
  // );

  useEffect(() => {
    setproductImages(selectedVariant?.Product_Images);
  }, [selectedVariant]);

  // const productImages = selectedVariant?.Product_Images || [];

  // const productImages = [
  //   ...(selectedVariant?.Product_Images?.map((item) => item.image) || []),

  //   ...(selectedVariant?.Product_Images?.length
  //     ? []
  //     : product?.Product_Images?.map((item) => item.image) || []),

  //   ...(selectedVariant?.image ? [selectedVariant.image] : []),

  //   ...(product?.image ? [product.image] : []),
  // ].filter(
  //   (img, index, self) => img && img !== "null" && self.indexOf(img) === index,
  // );

  // const currentIndex = productImages.findIndex((img) => img === activeImage);

  // const handlePrev = () => {
  //   const prevIndex =
  //     currentIndex === 0 ? productImages.length - 1 : currentIndex - 1;

  //   setActiveImage(productImages[prevIndex]);
  // };

  // const handleNext = () => {
  //   const nextIndex =
  //     currentIndex === productImages.length - 1 ? 0 : currentIndex + 1;

  //   setActiveImage(productImages[nextIndex]);
  // };

  useEffect(() => {
    if (productImages.length > 0) {
      setActiveImage(productImages[0]);
    }
  }, [productImages]);

  // useEffect(() => {
  //   if (productImages.length <= 1) return;

  //   const interval = setInterval(() => {
  //     setActiveImage((prevImage) => {
  //       const currentIndex = productImages.findIndex(
  //         (img) => img === prevImage,
  //       );

  //       const nextIndex =
  //         currentIndex === productImages.length - 1 ? 0 : currentIndex + 1;

  //       return productImages[nextIndex];
  //     });
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, [productImages]);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 991);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  class Zoomable {
    constructor(element, config) {
      this.element = element;
      this.config = this._mergeConfig(config);

      const { initialZoom, minZoom, maxZoom } = this.config;

      this.zoomed = false;
      this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
      this.zoom = this.initialZoom;

      this.img = element.querySelector(".zoomable__img");
      this.img.draggable = false;
      this.element.style.setProperty("--zoom", this.initialZoom);

      this._addEventListeners();
    }

    static get Default() {
      return Default;
    }

    _addEventListeners() {
      this.element.addEventListener("mouseenter", () =>
        this._handleMouseover(),
      );
      this.element.addEventListener("mousemove", (evt) =>
        this._handleMousemove(evt),
      );
      this.element.addEventListener("mouseleave", () => this._handleMouseout());
      this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));
    }

    _handleMouseover() {
      if (this.zoomed) {
        return;
      }

      this.element.classList.add("zoomable--zoomed");
      this.zoomed = true;
    }

    _handleMousemove(evt) {
      if (!this.zoomed) {
        return;
      }

      const elPos = this.element.getBoundingClientRect();
      const percentageX = `${((evt.clientX - elPos.left) * 100) /
        elPos.width}%`;
      const percentageY = `${((evt.clientY - elPos.top) * 100) /
        elPos.height}%`;

      this.element.style.setProperty("--zoom-pos-x", percentageX);
      this.element.style.setProperty("--zoom-pos-y", percentageY);
    }

    _handleMouseout() {
      if (!this.zoomed) {
        return;
      }

      this.element.style.setProperty("--zoom", this.initialZoom);
      this.element.classList.remove("zoomable--zoomed");
      this.zoomed = false;
    }

    _handleWheel(evt) {
      if (!this.zoomed) {
        return;
      }

      evt.preventDefault();

      const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
      const { minZoom, maxZoom } = this.config;

      this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
      this.element.style.setProperty("--zoom", this.zoom);
    }

    _mergeConfig(config) {
      return {
        ...this.constructor.Default,
        ...(typeof config === "object" ? config : {}),
      };
    }
  }

  const Default = {
    initialZoom: 3,
    minZoom: 1.25,
    maxZoom: 4,
    zoomSpeed: 0.01,
  };

  const zoomableRef = useRef(null);

  useEffect(() => {
    if (isMobile) return;
    const element = zoomableRef.current;
    if (!element) return;

    const zoomable = new Zoomable(element);

    return () => {
      element.removeEventListener("mouseenter", zoomable._handleMouseover);
      element.removeEventListener("mousemove", zoomable._handleMousemove);
      element.removeEventListener("mouseleave", zoomable._handleMouseout);
      element.removeEventListener("wheel", zoomable._handleWheel);
    };
  }, [isMobile]);

  return (
    <section className="Product_details_swiper">
      <div className="main_img_holder">
        <div className="wishlist_div">
          <Best_seller_heart product={product} />
        </div>

        {/* <div className="img_holder" ref={zoomableRef}>
          <img
            className="Product_img zoomable__img"
            src={activeImage?.image}
            alt="Product"
          />
        </div> */}

        {isMobile ? (
          <Swiper
            slidesPerView={1}
            loop={productImages.length > 1}
            onSlideChange={(swiper) =>
              setActiveImage(productImages[swiper.realIndex])
            }
            className="mobile_product_swiper"
          >
            {productImages.map((img, index) => (
              <SwiperSlide key={index}>
                <div className="img_holder">
                  <img
                    src={img.image}
                    className="Product_img"
                    alt={`Product-${index}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="img_holder" ref={zoomableRef}>
            <img
              className="Product_img zoomable__img"
              src={activeImage?.image}
              alt="Product"
            />
          </div>
        )}

        {productImages.length > 1 && (
          <div className="image-pagination">
            {productImages.map((img, index) => (
              <button
                key={index}
                type="button"
                className={`pagination-dot ${
                  activeImage === img ? "active" : ""
                }`}
                onClick={() => setActiveImage(img)}
              />
            ))}
          </div>
        )}
      </div>

      {productImages.length > 1 && (
        <div className="swiper_holder">
          <Swiper
            // modules={[Autoplay]}
            // autoplay={{
            //   delay: 3000,
            //   disableOnInteraction: false,
            // }}
            allowTouchMove
            touchRatio={1}
            simulateTouch
            touchStartPreventDefault={false}
            loop={true}
            breakpoints={{
              0: { slidesPerView: 4, spaceBetween: 10 },
              486: { slidesPerView: 4, spaceBetween: 10 },
              576: { slidesPerView: 5, spaceBetween: 10 },
              768: { slidesPerView: 6, spaceBetween: 10 },
              992: { slidesPerView: 4, spaceBetween: 10 },
              1200: { slidesPerView: 5, spaceBetween: 10 },
              1400: { slidesPerView: 5, spaceBetween: 10 },
              1800: { slidesPerView: 5, spaceBetween: 10 },
            }}
            className="Product_details_Swiper_holder"
          >
            {productImages.map((img, index) => (
              <SwiperSlide key={index} onClick={() => setActiveImage(img)}>
                <div
                  className={`img_holder ${
                    activeImage === img ? "active_thumb" : ""
                  }`}
                >
                  <img
                    className="Product_img "
                    src={img?.image}
                    alt={`Product-${index}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </section>
  );
}

export default Product_details_swiper;
